export const SignLandingPageType = {
	SignedThankYou: 'signed-thank-you/:id/:user',
	SignedRejected: 'signed-rejected/:id/:user/:creator',

	AlreadySigned: 'already-signed/:id',
	CanSignInFuture: 'can-sign-in-future',
	NotInActiveStation: 'not-in-active-station',

	CycleCompleted: 'cycle-completed/:id',
	CycleRejected: 'cycle-rejected/:creator/:rejected_by',
	CycleCanceled: 'cycle-canceled/:creator',

	CycleExpired: 'cycle-expired/:creator',
	CycleNotSignable: 'cycle-not-signable',
	UnrecognizedCycle: 'unrecognized-cycle',
} as const;
export type SignLandingPageType = (typeof SignLandingPageType)[keyof typeof SignLandingPageType];
